import type { SeedJourneySuggestion, SeedProject } from "../../../api/lifeOs";
import type { LifeProjectConfig } from "./LifeProjects";

/** Everything the seeder learned about a project that the room needs later —
 *  previously only lens+status survived materialization. */
export function buildLifeProjectConfig(
  pr: SeedProject,
  spaceIdByName: Record<string, string>,
  journeySuggestions: SeedJourneySuggestion[],
  wantsActive: boolean
): LifeProjectConfig {
  const cfg: LifeProjectConfig = {
    lens: pr.lens,
    status: wantsActive ? "promote" : "someday",
  };
  if (pr.whyNow) cfg.whyNow = pr.whyNow;
  if (pr.spaceName) {
    cfg.spaceName = pr.spaceName;
    const spaceId = spaceIdByName[pr.spaceName];
    if (spaceId) cfg.spaceId = spaceId;
  }
  const suggestion = journeySuggestions.find((j) => j.projectTitle === pr.title);
  if (suggestion) cfg.journeySuggestedReason = suggestion.reason;
  return cfg;
}
